import { render, staticRenderFns } from "./ShowLead.vue?vue&type=template&id=4b21a9dc&"
import script from "./ShowLead.vue?vue&type=script&lang=js&"
export * from "./ShowLead.vue?vue&type=script&lang=js&"
import style0 from "./ShowLead.vue?vue&type=style&index=0&id=4b21a9dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports